import { Alert, Typography } from "@mui/material";
import ColumnContainer from "./ColumnContainer";
import { FormattedMessage } from "react-intl";

export const ErrorLoading = () => {
  return (
    <ColumnContainer center>
      <Alert variant="filled" severity="error">
        <FormattedMessage id="alert.loadingError"></FormattedMessage>
      </Alert>
    </ColumnContainer>
  );
};
